import { ChangeEvent, FC, useCallback } from 'react';

import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { selectBlackFridayEtazhiFilter } from 'shared/selectors/advancedFilters/blackFridayEtazhi';
import { CustomCheckbox } from 'shared/components/CustomCheckbox';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';

/**
 * @todo: Код появился в задаче CD-250097, удалить в задаче CD-250490.
 */
export const BlackFridayEtazhiContainer: FC = () => {
  const { value, filterData, visible } = useSelectorWithConfig(selectBlackFridayEtazhiFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, value: boolean) => {
      onChange({ action: 'setBlackFridayEtazhi', arguments: [value || null] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={filterData?.name as string}>
      <InlineFilter width={410}>
        <CustomCheckbox
          label={filterData?.title}
          checked={value}
          onChange={handleChange}
          caption={filterData?.subtitle}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
